import React, { useCallback } from 'react';
import { Flex, Circle, Stack, Text } from '@tapresearch/ui/components';
export var LineChartLegend = function(param) {
    var series = param.series, colors = param.colors, direction = param.direction, visiblePoints = param.visiblePoints, onItemClick = param.onItemClick;
    var onItemClickCallback = useCallback(function(e) {
        var _e_currentTarget;
        var seriesIndex = ((_e_currentTarget = e.currentTarget) === null || _e_currentTarget === void 0 ? void 0 : _e_currentTarget.dataset).seriesIndex;
        if (seriesIndex !== undefined) onItemClick(+seriesIndex);
    }, [
        onItemClick
    ]);
    if (!series.length) return null;
    return /*#__PURE__*/ React.createElement(Stack, {
        "data-testid": "line-chart-legend",
        spacing: 1,
        alignItems: "flex-start",
        direction: direction,
        ml: 12,
        pt: 2,
        pl: 4,
        pb: 4,
        mb: 10
    }, series.map(function(answer, i) {
        var isVisible = !visiblePoints.length || visiblePoints.includes(i);
        return /*#__PURE__*/ React.createElement(Flex, {
            key: "answer-".concat(i),
            "data-testid": isVisible ? 'legend-item-visible' : 'legend-item-hidden',
            "data-series-index": i,
            onClick: onItemClickCallback,
            role: 'button',
            align: 'center',
            p: 2,
            rounded: 'md',
            transitionProperty: 'common',
            transitionDuration: 'normal',
            color: !isVisible ? 'gray.300' : 'gray.800',
            _hover: {
                bg: 'gray.50'
            }
        }, /*#__PURE__*/ React.createElement(Circle, {
            as: Flex,
            alignItems: "center",
            boxSize: 3,
            bg: !isVisible ? 'gray.100' : colors[i]
        }), /*#__PURE__*/ React.createElement(Text, {
            ml: 2
        }, answer.id));
    }));
};
